const { Type } = require('@sinclair/typebox');
const Blockly = require('blockly');
const { actionUtils } = require('@sstdev/lib_metadata-config');
const mdcConfig = require('@sstdev/lib_metadata-config');
const dataAccessMethods = require('../../../../dataAccessMethods');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const { config } = mdcConfig;

const TOOLTIP = 'Display a read only text from some namespace/relation (e.g. identity/profile displayName)';

/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    let workspace = blocklyBlock.workspace;
    let blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);

    line1OfInputs
        .appendField('  Namespace:')
        .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
        .appendField('  Relation:')
        .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)), 'relation')
        .appendField('  Property Name:')
        .appendField(new Blockly.FieldTextInput(''), 'propertyName');

    const line2OfInput = blocklyBlock.appendDummyInput().setAlign(Blockly.ALIGN_RIGHT);
    const sizeDropDown = new Blockly.FieldDropdown(config.textSizes);
    sizeDropDown.setValue('sm');
    const weightDropDown = new Blockly.FieldDropdown(config.textStyles);
    weightDropDown.setValue('regular');

    line2OfInput.appendField('  Text Size:').appendField(sizeDropDown, 'textSize');
    line2OfInput.appendField('  Text Weight:').appendField(weightDropDown, 'textWeight');
}

/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function convertCustomFieldsToCode(code, blocklyBlock) {
    // the main text is in `title`, handles centrally
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['namespace', 'relation', 'propertyName', 'textSize', 'textWeight']);
    return code;
}

/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function asDataDictionary(hNode, context = {}, parentAccessRestrictions) {
    const { namespace, relation, propertyName } = hNode;

    const accessRestrictions = actionUtils.getNodeAccessRestrictions(hNode, context, parentAccessRestrictions);
    if (accessRestrictions.hidden) return [{}, {}];

    // shortTextView displays read-only text from a namespace/relation property
    // It only requires GET access to read the data
    const accessContext = {
        get: { value: true },
        post: { value: false },
        patch: { value: false },
        remove: { value: false }
    };

    // Build a relation schema that indicates we need read access to this relation
    // The actual property type is unknown at design time, so we use additionalProperties: true
    const relationSchema = Type.Object(
        {},
        {
            title: relation,
            additionalProperties: true,
            'x-accessRestrictions': accessRestrictions,
            'x-accessContext': accessContext
        }
    );

    // subDataDictionary defines the namespace/relation structure for metadata assembly
    const subDataDictionary = {
        [namespace]: {
            [relation]: relationSchema
        }
    };

    // shortTextView is read-only display, it doesn't contribute properties to a form
    const partialTypeDefinition = {};

    return [subDataDictionary, partialTypeDefinition];
}
module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary };
